import { manageError, manageResponse } from './api-util'
import { http } from './http'

const deleteAttachmentOnDatabase = async (id: number) => {
  try {
    const response: MyResponse<string> = await http.delete('/attachment', {
      data: { id },
    })
    return manageResponse(response) as string
  } catch (error) {
    manageError(error)
  }
}

export { deleteAttachmentOnDatabase }
